module.exports = __webpack_public_path__ + "static/media/product1.7d782330.png";